import React from "react";

const EmptyLayout = ({ children }: any) => {
    return <div>{children}</div>;
};

export default EmptyLayout;
